import { render, staticRenderFns } from "./WcagAuditToolbar.vue?vue&type=template&id=3bcb3457&scoped=true"
import script from "./WcagAuditToolbar.vue?vue&type=script&lang=js"
export * from "./WcagAuditToolbar.vue?vue&type=script&lang=js"
import style0 from "./WcagAuditToolbar.vue?vue&type=style&index=0&id=3bcb3457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb3457",
  null
  
)

export default component.exports